/**
 * @file Text Hero.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Text hero.
 */
const textHero = () => {
	const hero = document.querySelector('.v-text-hero');
	if (!hero) return;

	gsap.registerPlugin(ScrollTrigger);

	const heroAngles = hero.querySelector('.v-text-hero__angles');
	const heroTl = gsap.timeline({
		scrollTrigger: {
			trigger: 'body',
			start:   'top top',
			end:     () => window.innerWidth * 0.260416667,
			scrub:   true,
		},
	});
	heroTl
		.to(heroAngles, {
			scaleY:   0,
			duration: 1,
		});
};

export default textHero;
